
<template>
  <div class="card">
    <div v-if="pdfUrl" class="pdf-container">
      <PdfViewer :src="pdfUrl" />
    </div>
    <div v-else class="no-pdf-message">
      <p>No PDF file available</p>
    </div>
  </div>
</template>

<script>

import PdfViewer from './PDFViewer.vue';


export default {
  name: 'EmploiCard',
  components: { PdfViewer},
  props: {
    job: Object,
    pdfFile: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      pdfUrl: null
    }
  },
  watch: {
    pdfFile: {
      immediate: true,
      handler(newFile) {
        if (newFile) {
          this.pdfUrl = process.env.VUE_APP_API_HOST + newFile.path;
        } else {
          this.pdfUrl = null;
        }
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  margin: 20px 0;
  background-color: #fff;
  height: 100%;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: fit-content;
}

.pdf-container {
  width: 100%;
  min-height: 60vh;
  height: 100%;
  display: flex;
}

.pdf-embed {
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  display: block;
  object-fit: cover; /* May help eliminate black bars on some browsers */
}

.no-pdf-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  border: 1px solid #eee;
  border-radius: 4px;
  color: #999;
}
</style>
